// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';

// project imports
import Logo from '@/components/mantis-logo';

import useConfig from '@/theme/useConfig';
import { MenuOrientation } from '@/theme/config';
import DrawerHeaderStyled from './DrawerHeaderStyled';

interface Props {
	open: boolean;
}

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }: Props) {
	const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

	const { state } = useConfig();
	const isHorizontal = state.menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

	return (
		<DrawerHeaderStyled
			open={open}
			sx={{
				minHeight: isHorizontal ? 'unset' : '60px',
				width: isHorizontal ? { xs: '100%', lg: '424px' } : 'initial',
				paddingTop: isHorizontal ? { xs: '10px', lg: '0' } : '24px',
				paddingBottom: isHorizontal ? { xs: '18px', lg: '0' } : '0px',
				paddingLeft: isHorizontal ? { xs: '24px', lg: '0' } : open ? '24px' : 0
			}}
		>
			<Logo
				isIcon={!open}
				sx={{ width: open ? 'auto' : 36, height: open ? 'auto' : 36 }}
			/>
		</DrawerHeaderStyled>
	);
}
